export default "__VITE_ASSET__1b138648__"